import React, { useEffect } from "react";
import { formatNumber } from "@/util/sums";
import ColFormValueSlider from "./ColFormValueSlider";
import { useController, useFormContext, useWatch } from "react-hook-form";
import clamp from "@/util/clamp";
import ControlledFormField from "@/model/interface/ControllerRangeSlider";
import { CalculatorField } from "@/model/interface/CalculatorTypes";

const calculateRemainingMortgageValue = (depsArray: number[]) => {
  const [homeValue] = depsArray;

  const minAmount = homeValue * 0.05 || 50000;
  const maxAmount = homeValue * 0.9 || 2250000;
  const calcValue = homeValue * 0.4;

  return {
    defaultValue: 650000,
    minAmount,
    maxAmount,
    value: clamp(calcValue, minAmount, maxAmount),
  };
};

const fieldName = CalculatorField.OutstandingValue;
const fieldWatched = CalculatorField.HomeValue;

const MortgageEstOutstanding: React.FC<ControlledFormField> = ({ fieldPrefix }) => {
  const targetName = [fieldPrefix, fieldName].filter(Boolean).join(".");
  const dependency = [fieldPrefix, fieldWatched].filter(Boolean).join(".");

  const { control, setValue } = useFormContext();
  const depsArray = useWatch({ control, name: [dependency] });

  const { value, defaultValue, ...minMaxParams } = calculateRemainingMortgageValue(depsArray);

  const { field } = useController({
    control,
    name: targetName,
    defaultValue,
  });

  useEffect(() => {
    if (!value) return;
    setValue(targetName, value);
  }, [depsArray]);

  return (
    <ColFormValueSlider
      title="Estimated mortgage outstanding value"
      step={1000}
      value={field.value}
      {...minMaxParams}
      rightColumnValue={field.value}
      rightColumnFormatFunction={(value) => `$${formatNumber(value, 0, true)}`}
      onFinalChange={field.onChange}
      onChange={field.onChange}
    />
  );
};

export default MortgageEstOutstanding;
